import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { ContractFilters } from '@types'

import { ContractsApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los contratos',
  })
}

const useContracts = (filters?: ContractFilters) => {
  const { data: contracts, isLoading: contractsIsLoading } = useQuery(
    [QUERY_KEYS.CONTRACTS, { filters }],
    () => ContractsApi.getContracts({ filters }),
    {
      staleTime: Infinity,
      onError,
    },
  )

  const { data: contractsFilters, isLoading: contractsFiltersIsLoading } = useQuery(
    [QUERY_KEYS.CONTRACTS_FILTERS, filters?.carrierId, filters?.asnum],
    () =>
      ContractsApi.getContractsFilter({
        filters: { carrierId: filters?.carrierId, asnum: filters?.asnum },
      }),
  )

  const { data: asnums, isLoading: asnumsIsLoading } = useQuery(
    [QUERY_KEYS.ROUTES_ASNUMS, filters?.carrierId, filters?.contract],
    () =>
      ContractsApi.getAsnums({
        filters: { carrierId: filters?.carrierId, contract: filters?.contract },
      }),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    asnums,
    asnumsIsLoading,
    contracts,
    contractsIsLoading,
    contractsFilters,
    contractsFiltersIsLoading,
  }
}

export { useContracts }
